import { compact, orderBy } from 'lodash-es';
import { extractPureTextFromRichText } from 'seagull/components/RichTextEditor/RichTextEditor';
import { getTemplateType } from '~/components/AgreementStudioPage/AgreementStudioModal/IntroMessage/IntroMessage.utils';
import { approvalMethodNoticePeriodModel } from '~/models';
import styles from './EditDraftsTableRow.module.scss';
import { EditDraftsTableColumns, ColumnSortId } from './types';
export const editDraftsTableTextsPath = 'pages.draftsDashboard.editTable';
export const editDraftsTableColumnsTextsPath = 'pages.draftsDashboard.editTable.columns';
export const editDraftsTableHeaderColumnDefs = (visibleColumns, texts)=>compact([
        {
            value: texts.primaryContact(),
            sortId: ColumnSortId.PrimaryContact,
            width: 240,
            sortable: true,
            sticky: true,
            bi: {
                name: 'sort_edit_drafts_by_primary_contact'
            }
        },
        visibleColumns[EditDraftsTableColumns.AdditionalRecipients] && {
            value: texts.additionalRecipients(),
            sortId: ColumnSortId.AdditionalRecipients,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_additional_recipients'
            }
        },
        visibleColumns[EditDraftsTableColumns.AgreementName] && {
            value: texts.agreementName(),
            sortId: ColumnSortId.AgreementName,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_agreement_name'
            }
        },
        visibleColumns[EditDraftsTableColumns.EffectiveDate] && {
            value: texts.effectiveDate(),
            sortId: ColumnSortId.EffectiveDate,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_effective_date'
            }
        },
        visibleColumns[EditDraftsTableColumns.ModifiedBy] && {
            value: texts.modifiedBy(),
            sortId: ColumnSortId.ModifiedBy,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_modified_by'
            }
        },
        visibleColumns[EditDraftsTableColumns.LastModified] && {
            value: texts.lastModified(),
            sortId: ColumnSortId.LastModified,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_last_modified'
            }
        },
        visibleColumns[EditDraftsTableColumns.ExpirationDate] && {
            value: texts.expirationDate(),
            sortId: ColumnSortId.ExpirationDate,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_expiration_date'
            }
        },
        visibleColumns[EditDraftsTableColumns.IntroductoryMessage] && {
            value: texts.introductoryMessage(),
            sortId: ColumnSortId.IntroductoryMessage,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_introductory_message'
            }
        },
        visibleColumns[EditDraftsTableColumns.TermsOfService] && {
            value: texts.termsOfService(),
            sortId: ColumnSortId.TermsOfService,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_terms_of_service'
            }
        },
        visibleColumns[EditDraftsTableColumns.AgreementNote] && {
            value: texts.agreementNote(),
            sortId: ColumnSortId.AgreementNote,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_agreement_note'
            }
        },
        visibleColumns[EditDraftsTableColumns.AutoApproveAmendments] && {
            value: texts.autoApproveAmendments(),
            sortId: ColumnSortId.AutoApproveAmendments,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_auto_approve_amendments'
            }
        },
        visibleColumns[EditDraftsTableColumns.AutoApproveOutOfScopeCharges] && {
            value: texts.autoApproveOutOfScopeCharges(),
            sortId: ColumnSortId.AutoApproveOutOfScopeCharges,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_auto_approve_out_of_scope_charges'
            }
        },
        visibleColumns[EditDraftsTableColumns.NumberOfDaysUntilPaymentIsDue] && {
            value: texts.numberOfDaysUntilPaymentIsDue(),
            sortId: ColumnSortId.NumberOfDaysUntilPaymentIsDue,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_number_of_days_until_payment_is_due'
            }
        },
        visibleColumns[EditDraftsTableColumns.PaymentMethodRequiredForSigning] && {
            value: texts.paymentMethodRequiredForSigning(),
            sortId: ColumnSortId.PaymentMethodRequiredForSigning,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_payment_method_required_for_signing'
            }
        },
        visibleColumns[EditDraftsTableColumns.CreditCardProcessingFees] && {
            value: texts.cardProcessingFees(),
            sortId: ColumnSortId.CreditCardProcessingFees,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_credit_card_processing_fees'
            }
        },
        visibleColumns[EditDraftsTableColumns.ManualApprovalOfEachPayment] && {
            value: texts.manualApprovalOfEachPayment(),
            sortId: ColumnSortId.ManualApprovalOfEachPayment,
            width: 200,
            sortable: true,
            bi: {
                name: 'sort_edit_drafts_by_manual_approval_of_each_payment'
            }
        }
    ]);
export const getUICompanyName = (draft, contact, anchorSampleLabel)=>draft.isSample() ? anchorSampleLabel : contact ? contact.companyName() : '';
export const getAgreementName = (draft, unnamedDraftLabel)=>draft.title() || unnamedDraftLabel;
export const getModifiedBy = (draft)=>{
    const lastModifiedBy = draft.lastModifiedBy();
    return lastModifiedBy ? compact([
        lastModifiedBy.firstName,
        lastModifiedBy.lastName
    ]).join(' ') : '';
};
export const getFirstLegalTermsDocument = (draft)=>{
    const legalTermsDocuments = draft.legalTermsDocuments();
    return legalTermsDocuments.find((doc)=>doc !== null);
};
function textSearchDraft(search, draft, contact, anchorSampleLabel) {
    return "".concat(getUICompanyName(draft, contact, anchorSampleLabel), " ").concat(draft.title()).toLowerCase().includes(search);
}
export const getServicesTableDefs = ()=>[
        {
            width: 250,
            value: 'Service Name'
        },
        {
            width: 220,
            value: 'Billing'
        },
        {
            width: 120,
            value: 'Rate'
        },
        {
            width: 220,
            value: 'Description'
        },
        {
            width: 300,
            value: 'Advanced Settings'
        }
    ];
export const makeEditableTableItem = (value)=>({
        className: styles.cell,
        value
    });
export function filterDrafts(drafts, getContact, search, anchorSampleLabel) {
    return drafts.filter((draft)=>{
        const normalizedSearch = search.trim().toLowerCase();
        const contact = getContact(draft);
        return textSearchDraft(normalizedSearch, draft, contact, anchorSampleLabel);
    });
}
const makeSortPropertiesBySortId = (unnamedDraftLabel)=>({
        [ColumnSortId.PrimaryContact]: {
            iteratees: [
                (param)=>{
                    let { lowercaseCompanyName } = param;
                    return lowercaseCompanyName;
                },
                (param)=>{
                    let { contactName } = param;
                    return contactName;
                }
            ],
            reverseOrder: true
        },
        [ColumnSortId.AdditionalRecipients]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return draft.reviewers().length;
                }
            ]
        },
        [ColumnSortId.AgreementName]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return getAgreementName(draft, unnamedDraftLabel).toLowerCase();
                }
            ],
            reverseOrder: true
        },
        [ColumnSortId.EffectiveDate]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    var _draft_effectiveDateAsDate;
                    return ((_draft_effectiveDateAsDate = draft.effectiveDateAsDate()) === null || _draft_effectiveDateAsDate === void 0 ? void 0 : _draft_effectiveDateAsDate.getTime()) || 0;
                }
            ],
            reverseOrder: true
        },
        [ColumnSortId.ModifiedBy]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return getModifiedBy(draft).toLowerCase();
                }
            ]
        },
        [ColumnSortId.LastModified]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return draft.lastModifiedOn();
                }
            ]
        },
        [ColumnSortId.ExpirationDate]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return draft.expirationDaysAfterSending() || 0;
                }
            ]
        },
        [ColumnSortId.IntroductoryMessage]: {
            iteratees: [
                (param)=>{
                    let { introductoryMessageType } = param;
                    return introductoryMessageType;
                }
            ],
            reverseOrder: true
        },
        [ColumnSortId.TermsOfService]: {
            iteratees: [
                (param)=>{
                    let { lowercaseLegalTermsName } = param;
                    return lowercaseLegalTermsName;
                }
            ],
            reverseOrder: true
        },
        [ColumnSortId.AgreementNote]: {
            iteratees: [
                (param)=>{
                    let { extraClausePureText } = param;
                    return extraClausePureText;
                }
            ],
            reverseOrder: true
        },
        [ColumnSortId.AutoApproveAmendments]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    const amendmentsApprovalMethod = draft.amendmentsApprovalMethod();
                    return amendmentsApprovalMethod && approvalMethodNoticePeriodModel.noticePeriodDays(amendmentsApprovalMethod) || 0;
                }
            ]
        },
        [ColumnSortId.AutoApproveOutOfScopeCharges]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    const invoicesApprovalMethod = draft.invoicesApprovalMethod();
                    return invoicesApprovalMethod && approvalMethodNoticePeriodModel.noticePeriodDays(invoicesApprovalMethod) || 0;
                }
            ]
        },
        [ColumnSortId.NumberOfDaysUntilPaymentIsDue]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return draft.netTerms();
                }
            ]
        },
        [ColumnSortId.PaymentMethodRequiredForSigning]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return draft.requirePaymentMethod() ? 1 : 0;
                }
            ]
        },
        [ColumnSortId.CreditCardProcessingFees]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return !draft.coverCreditCardFees();
                },
                (param)=>{
                    let { draft, lowercaseCompanyName } = param;
                    const isPaidByClient = !draft.coverCreditCardFees();
                    return isPaidByClient ? lowercaseCompanyName : '';
                }
            ],
            reverseOrder: true
        },
        [ColumnSortId.ManualApprovalOfEachPayment]: {
            iteratees: [
                (param)=>{
                    let { draft } = param;
                    return draft.allowManualPayments() ? 1 : 0;
                }
            ]
        }
    });
export function sortDrafts(param) {
    let { drafts, sortId, sort, introductoryMessages, getContact, anchorSampleLabel, unnamedDraftLabel } = param;
    const enrichedDrafts = drafts.map((draft)=>{
        const contact = getContact(draft);
        return {
            draft,
            contact,
            lowercaseLegalTermsName: (()=>{
                if (sortId === ColumnSortId.TermsOfService) {
                    const legalTerms = getFirstLegalTermsDocument(draft);
                    return (legalTerms ? legalTerms.displayName : '').toLowerCase();
                }
                return '';
            })(),
            extraClausePureText: sortId === ColumnSortId.AgreementNote ? extractPureTextFromRichText(draft.extraClause()).trim() : '',
            lowercaseCompanyName: [
                ColumnSortId.PrimaryContact,
                ColumnSortId.CreditCardProcessingFees
            ].includes(sortId) ? getUICompanyName(draft, contact, anchorSampleLabel).toLowerCase() : '',
            contactName: sortId === ColumnSortId.PrimaryContact && contact ? contact.fullName().toLowerCase() : '',
            introductoryMessageType: sortId === ColumnSortId.IntroductoryMessage ? getTemplateType(draft.customNotificationText(), introductoryMessages) : ''
        };
    });
    const { iteratees, reverseOrder } = makeSortPropertiesBySortId(unnamedDraftLabel)[sortId];
    const sortingOrder = reverseOrder ? sort === 'asc' ? 'desc' : 'asc' : sort;
    const orders = new Array(iteratees.length).fill(sortingOrder);
    return orderBy(enrichedDrafts, iteratees, orders).map((d)=>d.draft);
}
